"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGovV1AminoConverters = void 0;
var utils_1 = require("../utils");
var createGovV1AminoConverters = function () {
    return {
        "/cosmos.gov.v1.MsgVote": {
            aminoType: "cosmos-sdk/v1/MsgVote",
            toAmino: function (msg) { return (__assign({ proposal_id: msg.proposal_id, voter: msg.voter, option: msg.option }, ((0, utils_1.isNotEmpty)(msg.metadata) && { metadata: msg.metadata }))); },
            fromAmino: function (msg) { return ({
                proposal_id: msg.proposal_id,
                voter: msg.voter,
                option: msg.option,
                metadata: msg.metadata,
            }); },
        },
    };
};
exports.createGovV1AminoConverters = createGovV1AminoConverters;
//# sourceMappingURL=gov.v1.amino.js.map